import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://zerodata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://zerodata.compo-soft.ru/documents';
  serverApi =  'https://zerodata.compo-soft.ru/api/v1';
  serverUrl =  'https://zerodata.compo-soft.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://zero.compo-soft.ru/';
  featureGroupPermissions = true;
}

export const environment = new EnvironmentAdminProd();
